import module from 'fan/proyecto/module.js'

export class FanProyectoDocumentosService {
  constructor($http, $api) {
    this.$http = $http
    this.$api = $api
  }

  get(idProyecto, periodo, ejercicio) {
    return this.$http.get('/api2/proyecto/documentos', {
      params: {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo},
    })
  }

  postReciboisr(idProyecto, ejercicio, periodo, file) {
    let data = new FormData()
    data.append('archivo', file)

    return this.$http.post('/api2/proyecto/documentos/recibo_pago_isr', data, {
      params: {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo},
    })
  }

  getReciboisr(idProyecto, ejercicio, periodo, name) {
    return this.$api.open('/api2/proyecto/documentos/recibo_pago_isr',
      {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo, name: name},
    )
  }

  deleteReciboisr(idProyecto, ejercicio, periodo, name) {
    return this.$http.delete('/api2/proyecto/documentos/recibo_pago_isr', {
      params: {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo, name: name},
    })
  }

  postRecibosar(idProyecto, ejercicio, periodo, file) {
    let data = new FormData()
    data.append('archivo', file)

    return this.$http.post('/api2/proyecto/documentos/recibo_pago_sar', data, {
      params: {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo},
    })
  }

  getRecibosar(idProyecto, ejercicio, periodo, name) {
    return this.$api.open('/api2/proyecto/documentos/recibo_pago_sar',
      {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo, name: name},
    )
  }

  deleteRecibosar(idProyecto, ejercicio, periodo, name) {
    return this.$http.delete('/api2/proyecto/documentos/recibo_pago_sar', {
      params: {id_proyecto: idProyecto, ejercicio: ejercicio, periodo: periodo, name: name},
    })
  }
}

module.service('FanProyectoDocumentosService', FanProyectoDocumentosService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Documentos.js